import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './components/LoginPage';
import RegisterPage from './components/RegisterPage';
import HomePage from './components/HomePage';
import UpdateHoSoPage from './components/UpdateHoSoPage';
import LoadingPage from './components/LoadingPage';
import IdentificationPage from './components/IdentificationPage';
import BankRegistrationPage from './components/BankRegistrationPage';
import QRCodePage from './components/qrcode';
import ActivityTracker from './components/ActivityTracker';
import CommandPrompt from './components/CommandPrompt';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <Router>
      <div className="m-0 p-0 min-h-screen">
        <ActivityTracker />
        <CommandPrompt />
        <Routes>
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/home" element={<ProtectedRoute><HomePage /></ProtectedRoute>} />
          <Route path="/profile" element={<ProtectedRoute><UpdateHoSoPage /></ProtectedRoute>} />
          <Route path="/loading" element={<ProtectedRoute><LoadingPage /></ProtectedRoute>} />
          <Route path="/qrcode" element={<ProtectedRoute><QRCodePage /></ProtectedRoute>} />
          <Route path="/identification" element={<ProtectedRoute><IdentificationPage /></ProtectedRoute>} />
          <Route path="/bank-registration" element={<ProtectedRoute><BankRegistrationPage /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
